import React from "react";
import classes from "./CuratorCard.module.css";

const CuratorCard = ({ curatorViewModel }) => {
  return (
    <div className={classes["curator-card"]}>
      <p className={classes["curator-card-price-line"]}>
        {curatorViewModel.priceLine}
      </p>
      <p className={classes["curator-card-trip-date"]}>
        {curatorViewModel.tripDate}
      </p>
      <img
        className={classes["curator-card-curator-bg-img"]}
        src={curatorViewModel.curatorBgImg}
        alt=""
      />
      <img
        className={classes["curator-card-curator-img"]}
        src={curatorViewModel.curatorImg}
        alt=""
      />
      <p className={classes["curator-intro-name"]}>
        Meet The Curator: {curatorViewModel.curatorName}
      </p>
      <p className={classes["curator-intro-desc"]}>
        {curatorViewModel.curatorInfo}
      </p>
    </div>
  );
};

export default CuratorCard;
